export enum LoaderTypes {
  GLOBAL,
  LOCAL,
}
